import { browser } from '$app/environment';
import { goto } from '$app/navigation';
import { me } from '$src/stores/user.store';
import type { IUser } from 'garden-common';
import { get } from 'svelte/store';

//!Depricated please remove this function from use
export const getAuthUser = (redirect?: boolean): IUser<string> => {
  if (browser) {
    return get(me);
  }
};
